import { ROUTES, RouterModule } from '@angular/router';

import { NgModule } from '@angular/core';
import { TEXTS_VARIABLE } from 'src/app/shared/constants/constants-texts';
import { QuestionInfoModule } from './questionInfo/questionInfo.module';
import { SubCategoryModule } from './subCategory/subCategory.module';
import { CategoriesModule } from './categories/categories.module';
import { QuestionListModule } from './questionList/questionList.module';
import { SearchModule } from './search/search.module';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function setRoutes() {
  return [
    {
      path: '',
      data: { breadcrumb: 'Inicio', path: 'https://naranjax.com' },
      loadChildren: (): Promise<CategoriesModule> => {
        return import('./categories/categories.module').then(
          m => m.CategoriesModule,
        );
      },
    },
    {
      path: 'categoria',
      loadChildren: (): Promise<SubCategoryModule> =>
        import('./subCategory/subCategory.module').then(
          m => m.SubCategoryModule,
        ),
    },
    {
      path: 'subcategoria',
      loadChildren: (): Promise<SubCategoryModule> =>
        import('./subCategory/subCategory.module').then(
          m => m.SubCategoryModule,
        ),
    },
    {
      path: 'preguntas',
      loadChildren: (): Promise<QuestionListModule> =>
        import('./questionList/questionList.module').then(
          m => m.QuestionListModule,
        ),
    },
    {
      path: 'busqueda',
      loadChildren: (): Promise<SearchModule> =>
        import('./search/search.module').then(m => m.SearchModule),
    },
    {
      path: ':name',
      loadChildren: (): Promise<QuestionInfoModule> =>
        import('./questionInfo/questionInfo.module').then(
          m => m.QuestionInfoModule,
        ),
      data: {
        breadcrumb: (): string => `${TEXTS_VARIABLE.breadcrumb.HelpCenter}`,
      },
    },
  ];
}

@NgModule({
  imports: [],
  exports: [RouterModule],
  providers: [
    {
      provide: ROUTES,
      useFactory: setRoutes,
      multi: true,
    },
  ],
})
export class FaqsRoutingModule {}
